import { Navigate, Outlet } from 'react-router-dom';
const RouteGuardIsAuthenticated = () => {
    const isAuth = localStorage.getItem('currentUser');
  return isAuth ? <Navigate to={'/dashboard'} /> : <Outlet />;
};
export default RouteGuardIsAuthenticated;